import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import s from "./Sidebar.module.scss";
import LinksGroup from "./LinksGroup/LinksGroup";
import { changeActiveSidebarItem, closeSidebar, openSidebar } from "../../actions/navigation.js";
import "eva-icons/style/eva-icons.css";
import MenuIcon from "../Icons/HeaderIcons/MenuIcon.js";
import { fetchDrsEbtLogs } from "../../actions/ebt_logs.js";
import { fetchRetailEbtLogs } from "../../actions/ebt_retail_logs.js";

const Sidebar = (props) => {
  // const [darkMode, setDarkMode] = useState(false);

  // Compute unprocessed log count for badge
  const unprocessedCountDrs = props.ebtLogs?.ebt_drs_logs?.filter(log => parseInt(log.is_processed, 10) === 0).length || 0;
  const unprocessedCountRetail = props.ebtRetailLogs?.ebt_retail_logs?.filter(log => parseInt(log.is_processed, 10) === 0).length || 0;

  // // Check for saved theme preference or default to light mode
  // useEffect(() => {
  //   const savedTheme = localStorage.getItem('theme');
  //   if (savedTheme === 'dark') {
  //     setDarkMode(true);
  //     document.documentElement.setAttribute('data-theme', 'dark');
  //   } else {
  //     setDarkMode(false);
  //     document.documentElement.setAttribute('data-theme', 'light');
  //   }
  // }, []);

  // const handleDarkModeToggle = () => {
  //   const newTheme = !darkMode;
    
  //   if (newTheme) {
  //     document.documentElement.setAttribute('data-theme', 'dark');
  //     localStorage.setItem('theme', 'dark');
  //   } else {
  //     document.documentElement.setAttribute('data-theme', 'light');
  //     localStorage.setItem('theme', 'light');
  //   }
    
  //   setDarkMode(newTheme);
  // };

  return (
    <nav className={`${s.root} ${props.sidebarOpened ? s.sidebarOpen : ''}`}> 
      <header className={s.logo}>
        <span className={s.title}>EURIEKA</span>
        <button
          className={s.burgerBtn}
          aria-label="Toggle sidebar"
          onClick={() =>
            props.sidebarOpened
              ? props.dispatch(closeSidebar())
              : props.dispatch(openSidebar())
          }
        > 
          <MenuIcon className={s.menuIcon} />
        </button>
      </header>
      <ul className={s.nav}>
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Overview"
          isHeader
          iconName={<i className="eva eva-home-outline" />}
          link="/resources/overview"
          index="clientDashboard"
          resourceName="ClientDashboard"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Overview"
          isHeader
          iconName={<i className="eva eva-home-outline" />}
          link="/resources/overview/demo"
          index="clientDashboardDemo"
          resourceName="ClientDashboardDemo"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Dashboard"
          isHeader
          iconName={<i className="eva eva-home-outline" />}
          link="/template/dashboard"
          index="dashboard"
          // badge="9"
          resourceName="Advisories"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Prediction"
          isHeader
          iconName={<i className="eva eva-compass-outline" />}
          link="/template/prediction"
          index="prediction"
          // badge="9"
          resourceName="Prediction"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="MCR"
          isHeader
          iconName={<i className="eva eva-monitor-outline" />}
          link="/resources/mcr_reports"
          index="reports"
          // badge="9"
          resourceName="MCR"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="MCR Lookahead"
          isHeader
          iconName={<i className="eva eva-clock-outline" />}
          link="/template/lookahead"
          index="lookahead"
          // badge="9"
          resourceName="Lookahead"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
            }
          activeItem={props.activeItem}
          header="Device Management"
          isHeader
          iconName={<i className="eva eva-settings-outline" />}
          link="/resources/device_management"
          index="device_management"
          resourceName="DeviceManagement"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Operations"
          isHeader
          iconName={<i className="eva eva-options-2-outline" />}
          link="/resources/operations"
          index="operations"
          resourceName="Monitoring"
          currentUser={props.currentUser}
        />
	{/*<LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Revenue"
          isHeader
          iconName={<i className="eva eva-credit-card-outline" />}
          link="/resources/revenue"
          index="revenue"
          resourceName="Revenue"
          currentUser={props.currentUser}
        />*/}
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Monitoring"
          isHeader
          iconName={<i className="eva eva-settings-outline" />}
          link="/resources/monitoring"
          index="monitoring"
          resourceName="Monitoring"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Solar"
          isHeader
          iconName={<i className="eva eva-sun-outline" />}
          link="/resources/solar_facilities"
          index="solar_facilities"
          resourceName="SolarFacilities"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Invoices"
          isHeader
          iconName={<i className="eva eva-file-text-outline" />}
          link="/resources/invoices"
          index="invoices"
          resourceName="Invoices"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Resources"
          isHeader
          iconName={<i className="eva eva-cube-outline" />}
          link="/resources/units"
          index="resources"
          childrenLinks={[
            {
              header: "Units",
              link: "/resources/units",
              resourceName: "Units",
            },
            {
              header: "Groups",
              link: "/resources/groups",
              resourceName: "Groups",
            },
            {
              header: "Buildings",
              link: "/resources/buildings",
              resourceName: "Buildings",
            },
            {
              header: "Facilities",
              link: "/resources/facilities",
              resourceName: "Facilities",
            },
            {
              header: "Maintenances",
              link: "/resources/maintenances",
              resourceName: "Maintenances",
            },
          ]}
          resourceName="Units"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Offers (IL)"
          isHeader
          iconName={<i className="eva eva-pricetags" />}
          link="/resources/offers"
          index="dashboard"
          resourceName="Offers"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Bids (DR)"
          isHeader
          iconName={<i className="eva eva-pricetags-outline" />}
          link="/resources/bids"
          index="dashboard"
          resourceName="Bids"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="CDG Load Request"
          isHeader
          iconName={<i className="eva eva-car-outline" />}
          link="/resources/cdg_load_requests"
          index="cdg_load_requests"
          resourceName="CDGLoadRequests"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="EBT DRS"
          badge={unprocessedCountDrs > 0 ? unprocessedCountDrs : undefined}
          isHeader
          iconName={<i className="eva eva-briefcase-outline" />}
          link="/resources/ebt_drs_consumers"
          index="ebt_drs_consumers"
          resourceName="EBTDrsConsumers"
          currentUser={props.currentUser}
          childrenLinks={[
            {
              header: "Consumers",
              link: "/resources/ebt_drs_consumers",
              resourceName: "EBTDrsConsumers",
            },
            {
              header: "Inbox",
              link: "/resources/ebt_drs_inbox",
              resourceName: "EBTDrsInbox",
            },
          ]}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) => {
            props.dispatch(changeActiveSidebarItem(activeItem))
          }}
          activeItem={props.activeItem}
          header="EBT Retail"
          badge={unprocessedCountRetail > 0 ? unprocessedCountRetail : undefined}
          isHeader
          iconName={<i className="eva eva-briefcase-outline" />}
          link="/resources/ebt_retail_consumers"
          index="ebt_retail_consumers"
          resourceName="EBTRetailConsumers"
          currentUser={props.currentUser}
          childrenLinks={[
            {
              header: "Consumers",
              link: "/resources/ebt_retail_consumers",
              resourceName: "EBTRetailConsumers",
            },
            {
              header: "Inbox",
              link: "/resources/ebt_retail_inbox",
              resourceName: "EBTRetailInbox",
            },
          ]}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Period Average"
          isHeader
          iconName={<i className="eva eva-bar-chart-outline" />}
          link={"/resources/period_average"}
          index="calendar"
          resourceName="PeriodAverage"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Calendar"
          isHeader
          iconName={<i className="eva eva-calendar-outline" />}
          link={"/template/calendar"}
          index="calendar"
          resourceName="Calendar"
          currentUser={props.currentUser}
        />
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="User"
          isHeader
          iconName={<i className="eva eva-person-outline" />}
          link="/admin/"
          index="admin"
          // isAdmin={!props.currentUser || props.currentUser.role === "admin"}
          // adminRoute={true}
          exact={false}
          childrenLinks={[
            {
              header: "User Management",
              link: "/admin/users",
              resourceName: "UserManagement",
            },
            {
              header: "Change Password",
              link: "/template/password",
              resourceName: "ChangePassword",
            },
          ]}
          resourceName="ChangePassword"
          currentUser={props.currentUser}
        />
        {/* <li className={s.appearanceToggle}>
          <label className={s.toggleLabel}>Dark Mode</label>
          <input
            type="checkbox"
            checked={darkMode}
            onChange={handleDarkModeToggle}
            className={s.toggleInput}
          />
        </li> */}
      </ul>
    </nav>
  );
};

Sidebar.propTypes = {
  sidebarOpened: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  activeItem: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

function mapStateToProps(store) {
  return {
    currentUser: store.auth.currentUser,
    sidebarOpened: store.navigation.sidebarOpened,
    activeItem: store.navigation.activeItem,
    ebtLogs: store.ebtLogs,
  };
}

// Component to handle initial data loading
const SidebarWithLoad = (props) => {
  const { dispatch } = props;

  useEffect(() => {
    // Fetch EBT logs on component mount (first load or refresh)
    dispatch(fetchDrsEbtLogs(""));
    dispatch(fetchRetailEbtLogs(""));
  }, [dispatch]);

  return <Sidebar {...props} />;
};

export default withRouter(connect(mapStateToProps)(SidebarWithLoad));
